import { useGlobalContext } from "context/globalContext";
import React, { useCallback, useEffect } from "react";
import { IoMdClose } from "react-icons/io";

const SystemPromptsValueModal = ({ isOpen, onClose }) => {
  const {
    sysPromptsFormData,
    setSysPromptsFormData,
    initialSysPromptsFormState,
  } = useGlobalContext();

  const handleCancel = useCallback(() => {
    setSysPromptsFormData(initialSysPromptsFormState);
    onClose();
  }, [initialSysPromptsFormState, onClose, setSysPromptsFormData]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
      document.body.style.height = "100%";
    } else {
      document.body.style.overflow = "";
      document.body.style.height = "";
    }
    return () => {
      document.body.style.overflow = "";
      document.body.style.height = "";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <>
      {/* Black overlay */}
      <div
        className="fixed inset-0 z-[100] bg-[black] bg-opacity-75 transition-opacity"
        onClick={handleCancel}
      />

      {/* Modal content */}
      <div className="fixed inset-0 z-[101] flex h-screen items-center justify-center overscroll-contain">
        <div className="relative z-50 mx-auto flex h-auto max-h-[50dvh] w-auto min-w-[300px] flex-col items-center justify-start overflow-auto rounded-xl bg-white p-6 shadow-xl">
          <IoMdClose
            onClick={handleCancel}
            className="absolute top-4 right-4 cursor-pointer text-gray-600 hover:text-gray-800"
            size={24}
          />

          <div className="w-auto">
            <h2 className="mb-6 text-center text-2xl font-semibold text-gray-800">
              {"Value"}
            </h2>
            <div className="prose prose-lg max-w-none">
              <div className="rounded-md p-6">
                <p className="whitespace-pre-wrap text-gray-700">
                  {sysPromptsFormData?.value || "No value available"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SystemPromptsValueModal;
